import { ViewportScroller } from '@angular/common';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/services/api.service';
import { ModelConverterService } from 'src/app/services/model-converter.service';
import { AppSettings } from '../../app-settings';
import { Document } from '../../model/document';
import '@fortawesome/fontawesome-free/css/all.css';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpParams, HttpUrlEncodingCodec, HttpParameterCodec } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { ChangeDetectorRef } from '@angular/core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { tap } from 'rxjs/operators';

// Encoder personalizado para preservar el símbolo +
class CustomHttpParamEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }
  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }
  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}

@Component({
  selector: 'app-documentos-cea',
  templateUrl: './documentos-cea.component.html',
  styleUrls: ['./documentos-cea.component.css']
})
export class DocumentosCeaComponent implements OnInit {


  public documentos: any[] = [];
  public categorias: any[] = [];
  public categoria: any[] = [];
  productos: any[] = [];
  private baseUrl = '/Category';
  private basePath = '/api/resource';
  public data: any;
  collapsed: { [key: string]: boolean } = {};
  collapseds: { [key: string]: boolean } = {
    collapseDatasheet: true,
  };
  productName: string;
  categoryName: string;
  loadingRenting: boolean = false;
  isLoading: boolean = false;
  faSpinner = faSpinner;
  public documentosFiltrados: any[] = [];
  categoriasPorProducto: { [key: string]: any[] } = {};
  lastOpenedId: string | null = null;
  mostrarMensajeNoDocumentos: boolean = false;
  lenguageActual: string ='en';
  productosPorEmpresa: { [empresa: string]: any[] } = {};
  empresas: string[] = [];
  // Nuevo: almacenar documentos por producto y categoría
  documentosPorProductoCategoria: { [key: string]: any[] } = {};
  loadingPorCategoria: { [key: string]: boolean } = {};
  sinDocumentosPorCategoria: { [key: string]: boolean } = {};
  // Región del sitio. Este componente corresponde a la ruta /chile.
  region: string = 'Chile';





  @Input() document: Document;
  fileIconPath: string = `../../../${AppSettings.IMAGES_DIR}/file_icon.svg`;
  infoIconPath: string = `../../../${AppSettings.IMAGES_DIR}/info_icon.svg`;
  downloadIconPath: string = `../../../${AppSettings.IMAGES_DIR}/download_icon.svg`;
  documentImg: string = `../../../assets/imgs/documentos.svg`;

  constructor(
    private viewportScroller: ViewportScroller,
    private translate: TranslateService,
    private api: ApiService,
    private modelConverter: ModelConverterService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef
    
  ) {

  }

  ngOnInit() {
    this.getCategorias();
    this.getProductos();

    this.lenguageActual = "en";
  }
  
  toggleCollapse(id: string, productName: string, categoryName: string, event: MouseEvent) {

    event.stopPropagation();

    this.productName = productName;
    this.categoryName = categoryName;

    const isCurrentlyOpen = !this.collapsed[id];

    if (this.lastOpenedId === id && isCurrentlyOpen) {
        this.collapsed[id] = true;
        this.lastOpenedId = null;
        return;
    }

    console.log('Toggle categoria:', { id, productName, categoryName, categoriasDisponibles: this.categoriasPorProducto[productName], documentosLoaded: this.documentos });

    this.collapsed[id] = !this.collapsed[id];

    if (!this.collapsed[id]) {
        this.lastOpenedId = id;
    }

    if (!this.collapsed[id] && this.productName && this.categoryName) {
        Object.keys(this.collapsed).forEach(key => {
            if (key !== id) {
                this.collapsed[key] = true;
            }
        });
        this.getDocumentos(this.productName, this.categoryName);
    }
}
closeIfSameCategory(id: string, event: MouseEvent) {
  if (this.lastOpenedId === id) {
      this.collapsed[id] = true;
      this.lastOpenedId = null;

  }
}



  hayDocumentosParaCategoria(productoName: string, categoryName: string): boolean {
    return this.documentos.some(doc => doc.category === categoryName && doc.name === productoName);
  }


  getCategoriasPorProducto(producto: string) {
    // Codificar manualmente para asegurar que el + se preserve correctamente
    const productoEncoded = encodeURIComponent(producto);
    const params = new HttpParams({
      fromString: `producto=${productoEncoded}&region=${encodeURIComponent(this.region)}`,
      encoder: new CustomHttpParamEncoder()
    });

    console.log(`🔍 Solicitando categorías para: "${producto}" (región: ${this.region})`);
    console.log(`📤 URL completa: /api/method/docs_management.documents.getCategoriasPorProducto?producto=${productoEncoded}&region=${this.region}`);
    
    return this.http.get(`/api/method/docs_management.documents.getCategoriasPorProducto`, { params })
      .pipe(
        tap((response: any) => {
          console.log(`✅ Respuesta del servidor para "${producto}":`, response); 
          const categorias = response.message.categorias; 
          console.log(`📊 Categorías encontradas (${categorias?.length || 0}):`, categorias);
  
          this.categoriasPorProducto[producto] = categorias;
        }),
        catchError(error => {
          console.error(`❌ Error al obtener las categorías para "${producto}":`, error);
          return throwError(error);
        })
      );
  }
  
  
  

  getDocumentos(productName: string, categoryName: string) {
    const key = `${productName}_${categoryName}`;
    this.loadingPorCategoria[key] = true;

  
    let formData = {
      bussinessunit: productName,
      categoria: categoryName,
      language: 'en',
      region: this.region
    };
    console.log('Obteniendo documentos para:', formData); 

  
    this.api.getDocumentos(formData).subscribe({
      next: (r: any) => {
        console.log('📦 Respuesta completa del API getDocumentos:', r);
        console.log('📋 Total documentos recibidos:', r?.message?.documents?.length || 0);
        
        if (!r?.message?.documents) {
          console.warn('⚠️ No hay documentos en la respuesta');
          this.sinDocumentosPorCategoria[key] = true; 
          this.documentosPorProductoCategoria[key] = [];
          this.loadingPorCategoria[key] = false;
          return;
        }
        
        const documentosFiltrados = r.message.documents.filter((doc: any) => doc.category === categoryName);
        console.log('🔍 Documentos filtrados para', key, ':', documentosFiltrados);
        console.log('🔍 Categoría buscada:', categoryName);
        console.log('🔍 Categorías en documentos:', r.message.documents.map((d: any) => d.category));
        
        if (!documentosFiltrados.length) {
          console.warn('⚠️ No se encontraron documentos para la categoría:', categoryName);
          this.sinDocumentosPorCategoria[key] = true; 
          this.documentosPorProductoCategoria[key] = [];
        } else {
          console.log('✅ Documentos asignados a', key, ':', documentosFiltrados.length);
          this.sinDocumentosPorCategoria[key] = false;
          this.documentosPorProductoCategoria[key] = documentosFiltrados;
        }
        this.loadingPorCategoria[key] = false;
        // Forzar detección de cambios para actualizar la vista
        this.cdr.detectChanges();
      },
      error: (error: any) => {
        console.error("❌ Error al obtener los documentos:", error);
        this.loadingPorCategoria[key] = false;
        this.sinDocumentosPorCategoria[key] = true;
      }
    });
  }

  getCategoriasProducto(productoName: string): any[] {
    return this.categoriasPorProducto[productoName] || [];
  }

  getDocumentosDeCategoria(productName: string, categoryName: string): any[] {
    const key = `${productName}_${categoryName}`;
    return this.documentosPorProductoCategoria[key] || [];
  }

  isLoadingCategoria(productName: string, categoryName: string): boolean {
    const key = `${productName}_${categoryName}`;
    return this.loadingPorCategoria[key] || false;
  }

  sinDocumentosCategoria(productName: string, categoryName: string): boolean {
    const key = `${productName}_${categoryName}`;
    return this.sinDocumentosPorCategoria[key] || false;
  }
  
  
  
  
  
  


  scrollToTop() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  assignDocument(data: any) {
    this.document = this.modelConverter.convertDocument(data.data);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const scrollThreshold = 200;

    const scrollToTopButton = document.querySelector('.scroll-to-top');
    if (scrollToTopButton) {
      if (scrollPosition > scrollThreshold) {
        scrollToTopButton.classList.remove('hidden');
      } else {
        scrollToTopButton.classList.add('hidden');
      }
    }
  }

  filterDocumentos(productoName: string, categoryName: string): any[] {
    return this.documentos.filter(doc => doc.name == productoName && doc.category == categoryName);
  }

  getCategorias() {
    this.api.getCategorias().subscribe({
      next: (r: any) => {
        this.categorias = r.message.categorias;
        console.log(r.message);
        this.configureCollapsedState();
      }
    });
  }

  getProductos() {
    this.isLoading = true;

    this.api.getProductos(this.region).subscribe({
      next: (r: any) => {
        // El filtrado por región se hace en el backend (getProductos?region=...).
        // Aquí solo respetamos el flag show_title; sin exclusiones hardcodeadas.
        this.productos = r.message.products.filter((producto: any) => producto.show_title === 1);
        console.log('Respuesta completa del endpoint:', r.message);
        console.log('Productos (filtrados por región en el back, show_title = 1):', this.productos);
        
        // Log para verificar el campo brand y show_title
        console.log('=== Verificación de campos brand y show_title ===');
        this.productos.forEach((producto, index) => {
          console.log(`Producto ${index + 1} - ${producto.name1}:`, {
            brand: producto.brand,
            brand_name: producto.brand_name,
            show_title: producto.show_title,
            tieneBrand: !!(producto.brand || producto.brand_name)
          });
        });

        this.productos.forEach(producto => {
          const brand = producto.brand || producto.brand_name;
          const tieneBrand = brand && brand.trim() !== '';
          // Si no tiene brand, usar 'Otros' como empresa por defecto
          const empresa = tieneBrand ? brand.trim() : 'Otros';

          if (!this.productosPorEmpresa[empresa]) {
            this.productosPorEmpresa[empresa] = [];
          }

          this.productosPorEmpresa[empresa].push(producto);
        });

        // Obtener lista de empresas dinámicamente desde los productos agrupados
        // Ordenar manteniendo un orden preferencial si existe
        const ordenPreferencial = ['BYD BatteryBox', 'Dyness', 'BYD + EFTES', 'Vilion'];
        const empresasOrdenadas = ordenPreferencial.filter(emp => this.productosPorEmpresa[emp]);
        const otrasEmpresas = Object.keys(this.productosPorEmpresa)
          .filter(emp => !ordenPreferencial.includes(emp) && this.productosPorEmpresa[emp] && this.productosPorEmpresa[emp].length > 0)
          .sort();
        
        // Eliminar posibles marcas no deseadas dejando solo las permitidas
        const marcasPermitidas = new Set(['BYD BatteryBox', 'Dyness', 'BYD + EFTES', 'Vilion', 'Sosen', 'Otros']);

        // Incluir todas las empresas, no solo las permitidas (para Chile)
        this.empresas = [...empresasOrdenadas, ...otrasEmpresas];
        
        // No filtrar productosPorEmpresa - mostrar todos los productos

        console.log('Productos agrupados por empresa:', this.productosPorEmpresa);
        console.log('Empresas:', this.empresas);
        
        // Cargar categorías para cada producto
        this.productos.forEach(producto => {
          this.getCategoriasPorProducto(producto.name1).subscribe({
            next: () => {
              console.log(`Categorías cargadas para ${producto.name1}:`, this.categoriasPorProducto[producto.name1]);
              
              // Inicializar el estado collapsed para cada categoría del producto
              const categoriasDelProducto = this.categoriasPorProducto[producto.name1] || [];
              categoriasDelProducto.forEach(categoria => {
                const id = `${producto.name1}_${categoria.name}`;
                if (this.collapsed[id] === undefined) {
                  this.collapsed[id] = true; // true = cerrado
                }
              });
            },
            error: (err) => {
              console.error(`Error al cargar categorías para ${producto.name1}:`, err);
            }
          });
        });
        
        this.isLoading = false;
      }
    });
  }

  agruparProductosPorEmpresa() {
    // Reiniciar agrupación
    this.productosPorEmpresa = {};

    // Solo procesar productos con show_title = 1
    this.productos
      .filter(producto => producto.show_title === 1)
      .forEach(producto => {
        const brand = producto.brand || producto.brand_name;
        const tieneBrand = brand && brand.trim() !== '';

        const empresa = tieneBrand ? brand : 'Otros';

        if (!this.productosPorEmpresa[empresa]) {
          this.productosPorEmpresa[empresa] = [];
        }

        if (tieneBrand) {
          this.productosPorEmpresa[empresa].push(producto);
        } else {
          this.productosPorEmpresa['Otros'].push(producto);
        }
      });
 
    // Obtener lista de empresas dinámicamente desde los productos agrupados
    // Ordenar manteniendo un orden preferencial si existe
    const ordenPreferencial = ['BYD BatteryBox', 'Dyness', 'BYD + EFTES', 'Vilion'];
    const empresasOrdenadas = ordenPreferencial.filter(emp => this.productosPorEmpresa[emp]);
    const otrasEmpresas = Object.keys(this.productosPorEmpresa)
      .filter(emp => !ordenPreferencial.includes(emp))
      .sort();
    
    this.empresas = [...empresasOrdenadas, ...otrasEmpresas];

    console.log('Productos agrupados por empresa:', this.productosPorEmpresa);
    console.log('Empresas:', this.empresas);
    
  }
  

  configureCollapsedState() {
    this.productos.forEach((producto, i) => {
      this.categorias.forEach((categoria, j) => {
        const id = `${producto.name1}_${categoria.name}`;
        if (this.collapsed[id] === undefined) {
          this.collapsed[id] = true;
        }
      });
    });
  }


  downloadMultipleFiles(): void {
    const urls: string[] = [
      '/assets/HIGH RES RENDERS BatteryBox 2.zip',
      '/assets/HIGH RES RENDERS BatteryBox 3.zip'
    ];

    urls.forEach(url => {
      const link = document.createElement('a');
      link.href = url;
      link.download = url.split('/').pop() || 'archivo.zip';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }
}